import { ListingCardImage } from '../../components/ListingCard/types';
import { PhotoCarouselImage } from '../../components/common/PhotoCarousel/PhotoCarousel';

/**
 * Pick the source used by the large inline listing hero.
 *
 * The stored data cannot reliably distinguish bounded display images from
 * legacy originals: both old and new records commonly carry `originalUrl`
 * without `isDisplayOptimized`. Prefer the active full-size `url` for the hero;
 * JAA-399 will bound legacy originals in storage.
 */
export const toListingHeroImage = (image: ListingCardImage): PhotoCarouselImage => {
  // The legacy enhancement endpoint fell back to the original URL when
  // thumbnail creation failed. Keep that out of thumbnail-only consumers.
  const thumbnailUrl = image.thumbnailUrl
    && image.thumbnailUrl !== image.url
    && image.thumbnailUrl !== image.originalUrl
    ? image.thumbnailUrl
    : undefined;

  return {
    id: image.id,
    url: image.url,
    thumbnailUrl: thumbnailUrl || image.url,
    displayUrl: image.url,
  };
};
